import { render, staticRenderFns } from "./Question.vue?vue&type=template&id=93fa4e56&scoped=true&"
import script from "./Question.vue?vue&type=script&lang=ts&"
export * from "./Question.vue?vue&type=script&lang=ts&"
import style0 from "./Question.vue?vue&type=style&index=0&id=93fa4e56&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "93fa4e56",
  null
  
)

export default component.exports